const connection = io.connect(`${location.protocol}//${location.hostname}:4000/`);

module.exports = {
	connection
}
